export default __webpack_public_path__ + "dfaa19b6b928508e0393a5fc7c6d6641.gif";